module.exports = __webpack_public_path__ + "img/success.ff15cf4.svg";